<template>
  <v-app id="inspire">
    <v-main>
      <v-container
        class="fill-height d-flex align-center justify-center pa-0"
        style="background-color: var(--v-primary-base);"
        fluid
      >
        <v-card class="card py-4 px-6">
          <v-card-title class="d-flex justify-center pb-0">
            <p class="title my-0">Conta cadastrada com sucesso</p>
          </v-card-title>
          <div class="py-2 px-6">
            <v-divider />
          </div>
          <v-card-text class="text-center">
            <p v-if="!pj">
              Agora é conosco, vamos avaliar todos os dados preenchidos para
              seguir com a ativação da conta.
            </p>
            <p v-else>
              Em breve, os sócios/representantes legais da conta irão receber
              uma notificação para prosseguir com a validação biométrica.
            </p>
            <p class="sub mt-4">
              Em caso de dúvidas, entre em contato pelos nossos canais de
              atendimento:
              <br />
              <span class="d-block" style="color: #0094FF;">
                {{
                  dadosContato
                    ? `${dadosContato.Telefone} | ${dadosContato.Email}`
                    : "(11) 4858-8650 | atendimento@moneyp.com.br"
                }}
              </span>
            </p>
          </v-card-text>
        </v-card>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  props: {
    pj: {
      type: Boolean,
      default: false
    },
  },
  metaInfo: {
    title: window.env.VUE_APP_NOME
  },
  data () {
    return {
      dadosContato: JSON.parse(localStorage.getItem('dadosContato'))
    };
  }
};
</script>
<style scoped>
.background {
  background-position: center center;
  background-size: cover;
}
.card {
  position: absolute;
  align-items: center;
  text-align: center;
  width: 40%;
}

.title {
  font-family: Inter !important;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  color: #202020;
}

.main-text {
  text-align: center;
  color: #3A3939 !important;
  size: 14px !important;
  line-height: 22px !important;
  font-weight: 400 !important;
}
</style>
